module.exports = __webpack_public_path__ + "static/media/15.08e42e97.jpg";